import * as $ from "jquery";
import * as angular from "angular";
import { DataSetDataProvider } from "../../data-provider/data-set.dp";
import { EventDataProvider } from "../../data-provider/event.dp";
import { IntegrationDataProvider } from "../../data-provider/integration.dp";
import { Effort } from "../../models/effort.model";
import { Integration } from "../../models/integration.model";
import { PermissionCheck } from "../../shared/permission";
import { DialogUtils } from "../../helper/dialog.helper";
import { ToastUtils } from "../../helper/toast.helper";
import { EffortDataProvider } from "../../data-provider/effort.dp";
import * as _ from "lodash";
import { EventModel } from "../../models/event.model";

let EffortListComponent = {
    selector: "vcEffortList",
    templateUrl: "/angular/components/effort/effort-list.component.html",
    bindings: {
        efforts: "<",
    },
    controller: class EffortListController {
        // * bindings for typescript compiler *
        public efforts: any;
        // ************************************

        private integrations: Integration[];

        private $scope: any;
        private $window: any;
        private __env: any;
        private dialog: DialogUtils;
        private toast: ToastUtils;

        private dataProvider: EffortDataProvider;
        private eventDataProvider: EventDataProvider;
        public permissionProvider: PermissionCheck;
        public dataSetDataProvider: DataSetDataProvider;

        constructor(
            $scope: any,
            $window: any,
            __env: any,
            EffortDataProvider: EffortDataProvider,
            PermissionCheck: PermissionCheck,
            EventDataProvider: EventDataProvider,
            DialogUtils: DialogUtils,
            ToastUtils: ToastUtils,
            DataSetDataProvider: DataSetDataProvider,
            IntegrationDataProvider: IntegrationDataProvider
        ) {
            this.$scope = $scope;
            this.$window = $window;
            this.__env = __env;
            this.dialog = DialogUtils;
            this.toast = ToastUtils;

            this.dataProvider = EffortDataProvider;
            this.permissionProvider = PermissionCheck;
            this.eventDataProvider = EventDataProvider;
            this.dataSetDataProvider = DataSetDataProvider;

            IntegrationDataProvider.getAllIntegrations().then(
                (integrations: Integration[]) => {
                    this.integrations = integrations;
                }
            );
        }

        viewAnalytics(effort: Effort): void {
            this.dataProvider.setSelectedEffort(effort);
            this.$window.location = "/#/results";
        }

        viewTracking(effort: Effort): void {
            this.dataProvider.setSelectedEffort(effort);
            this.$window.location = "/#/canvasser/activity";
        }

        canManageEfforts(): boolean {
            return this.permissionProvider.hasPermission("CREATE_EFFORT");
        }

        openEffortDialog(effort: Effort, ev: object): void {
            effort = effort || new Effort();
            let parentEl = angular.element(document.body);

            this.dialog.show({
                parent: parentEl,
                component: "vc-effort-form",
                targetEvent: ev,
                scope: this.$scope,
                locals: {
                    effort: _.cloneDeep(effort),
                    __env: this.__env,
                },
                size: "auto",
                ariaLabel: "Create Campaign Effort",
                ngClass:
                    "{'flex-100 flex-gt-xs-95 flex-gt-md-80 flex-gt-lg-70' : !$ctrl.effort.id, 'flex-100 flex-gt-xs-80 flex-gt-md-60 flex-gt-lg-40' : $ctrl.effort.id}",
                onComplete: (s, e) => {
                    $(e).find("input").first().focus();
                },
            });
        }

        attachedToIntegration(effort: Effort): string {
            let title: string;
            angular.forEach(this.integrations, (integration: Integration) => {
                if (
                    integration.settings.effort &&
                    integration.settings.effort == effort.id
                ) {
                    title = integration.title;
                }
            });
            return title;
        }

        openArchiveEffortDialog(effort: Effort, ev: object): void {
            if (this.dataProvider.activeEfforts().length == 1) {
                this.toast.error(
                    "You must always have at least one active campaign effort, please create another effort before archiving this one."
                );
            } else {
                this.eventDataProvider
                    .all({ start: new Date(), effort: effort.id })
                    .then((events: object[]) => {
                        const integrationTitle =
                            this.attachedToIntegration(effort);

                        let eventsToHappen = events.filter(
                            (event: EventModel) => {
                                return event.status != "Cancelled";
                            }
                        );

                        if (eventsToHappen && eventsToHappen.length) {
                            this.toast.error(
                                "This effort is attached to " +
                                    eventsToHappen.length +
                                    " upcoming actions. " +
                                    "Please update these actions to change the associated effort before archiving."
                            );
                        } else if (integrationTitle) {
                            this.toast.error(
                                "This effort is attached to your " +
                                    integrationTitle +
                                    " integration. Please remove it from that integration before archiving."
                            );
                        } else {
                            this.dialog
                                .show({
                                    component: "vc-archive-effort-dialog",
                                    targetEvent: ev,
                                    scope: this.$scope,
                                    locals: {
                                        effort: effort,
                                    },
                                    ariaLabel: "Archive Effort",
                                })
                                .then(() => {
                                    effort.status = "Archiving";
                                    this.dataProvider
                                        .archiveEffort(effort)
                                        .then(() => {
                                            this.toast.success(
                                                "Effort Archived."
                                            );
                                        });
                                });
                        }
                    });
            }
        }

        isArchivedEffort(): (effort: Effort) => boolean {
            return (effort: Effort) => {
                return (
                    effort.status == "Archived" || effort.status == "Archiving"
                );
            };
        }
    },
};

angular
    .module("effort")
    .component(EffortListComponent.selector, EffortListComponent);
